import styled from 'styled-components';
import { Colors } from '../../../../../../constants';

import Icon from '../../../../../../components/Icon';
import Search from '../../../../../../components/Search';

const LoadingContainer = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SidePanel = styled.div` 
  z-index: 11;
  position: fixed;
  padding-left: 50%;
  background: var(--overlay);

  top: 0;
  left: 0;
  right: 0;  
  bottom: 0;

  display: flex;
  justify-content: flex-end;
`;

const SidePanelContent = styled.div`  
  flex: 1;
  overflow: auto;
  background-color: white;
  box-shadow: 3px 0 6px var(--box-shadow);  
`;

const TrackingManagerHeader = styled.div`
  background: ${Colors.PRIMARY_BLUE};
`;

const TrackingManagerToolbar = styled.div`
  display: flex;  
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 24px;
`;

const TrackingManagerToolbarTitle = styled.div`
  flex: 1;
  margin: 0;
  font-size: 24px;
  line-height: 24px;
  font-weight: normal;
  color: white;
`;

const HeaderContainer = styled.div`
  && h3 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    color: white;    
  }
`;

const TrackingManagerContent = styled.div`
  padding: 24px;
`;

const TrackingManagerAlert = styled.div`
  width: 100%;
  height: 64px;
  
  background: rgba(16, 119, 185, 0.24);
  border-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 16px 18px;
  margin-bottom: 24px;
`;

const TrackingManagerAlertText = styled.span`
  margin-left: 18px;  

  font-size: 14px;
  line-height: 16px;

  color: ${Colors.SECONDARY_DARKER_BLUE};
`;

const StyledSearch = styled(Search)`
  width: 480px;

  input { 
    border: 1px solid var(--luft-primary);
  }
`;


const ActionsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const TableRegister = styled.div`
  background: ${({ status }) => (
    status === 'Ativado' ?
      'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3;'
      : 'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F44336;')};

  border-radius: 4px;
  padding: 8px;

  width: 108px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const RegisterSituation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;  
  font-size: 14px;  
`;

const RegisterExpiredLink = styled.div`
  color: var(--luft-secondary-darker);
  font-size: 12px;
  text-decoration-line: underline;
  cursor: pointer;
`;

const TableRegisterSituation = styled.div`
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #2196F3;
  border-radius: 4px;
  padding: 8px;

  width: 108px;
  height: 48px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const FormContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  padding: 48px;

  border: 1px dashed #E0E0E0;
`;

const NoContactRegistered = styled.span`
  font-size: 16px;
  color: #666666;

  margin-bottom: 64px;
`;

const CloseButton = styled(Icon)`
  color: white;
  font-size: 24px;
  cursor: pointer;
  margin-top: 14px;
`;

export const S = {
  SidePanel,
  CloseButton,
  StyledSearch,
  FormContainer,
  HeaderContainer,
  SidePanelContent,
  TableRegister,
  RegisterSituation,
  RegisterExpiredLink,
  ActionsContainer,
  NoContactRegistered,
  TrackingManagerAlert,
  TrackingManagerHeader,
  TableRegisterSituation,
  TrackingManagerContent,
  TrackingManagerToolbar,
  TrackingManagerAlertText,
  TrackingManagerToolbarTitle,
  LoadingContainer,
};
